import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./index.pcss";

import "vue-neat-modal/dist/vue-neat-modal.css";
import { setDefaultProps } from "vue-neat-modal";
setDefaultProps({});

import VueFeather from "vue-feather";

createApp(App).use(router).component(VueFeather.name, VueFeather).mount("#app");
